import React, { useEffect, useRef, useState } from "react";
import {
  Map,
  ZoomControl,
  TileLayer,
  FeatureGroup,
  Popup,
} from "react-leaflet";
import L from "leaflet";
import { Tooltip, Marker } from "react-leaflet";
import { withSnackbar } from "notistack";
import { Layers as LayersIcon, Store as StoreIcon } from "@mui/icons-material";
import {
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Popover,
} from "@mui/material";

import Btn from "components/Custom/Btn";
import SkeletonBox from "components/Custom/SkeletonBox";
import MapSearchFilter from "components/Scavenging/MapSearchFilter";
import Loader from "components/Custom/Loader";

import {
  CONFIG,
  DEFAULTS,
  NOTIFY,
  LOCAL_STORAGE,
  SHOP_TYPES,
} from "common/config";
import { ERRORS, LABELS, SUCCESS, WARNINGS } from "common/lables";
import { COMMON_JS } from "common/scripts";
import { COLORS } from "common/colors";

import "react-leaflet-markercluster/dist/styles.min.css";
import "leaflet/dist/leaflet.css";

import "./styles/index.css";
import "./styles/fleetmap.css";

import { CUSTOMER_APIs } from "apihandlers/customer";
import { AI_APIS } from "apihandlers/ai";

const gopalImg = require("./images/marker-gopal.png");
const leads = require("./images/leads.png");
const customerMarker = require("./images/customers.png");

const Scavenging = (props: any) => {
  const { setPageMenu } = props;

  const shopsRef: any = useRef(null);
  const mapRef: any = useRef(null);

  const [loading, setLoading] = useState<boolean>(true);
  const [fromLatLng, setFromLatLng] = useState<any>({
    lat: 0,
    lng: 0,
  });
  const [toLatLng, setToLatLng] = useState<any>({
    lat: 0,
    lng: 0,
  });
  const [shopTypes, setShopTypes] = useState<any>(SHOP_TYPES);
  const [shopDetails, setShopDetails] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [mapTypes, setMapTypes] = useState<boolean>(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [saveLoading, setSaveLoading] = useState<boolean>(false);
  const [loadScavenging, setLoadScavenging] = useState<boolean>(false);
  const [customers, setCustomers] = useState<any>(null);
  const [showCustomer, setShowCustomer] = useState<boolean>(true);
  const [showLeadProfiles, setShowLeadProfiles] = useState<boolean>(true);
  const [leadProfile, setLeadProfile] = useState<any>(null);
  let mapLocalStorage: any = {
    lat: 22.3037252,
    lng: 70.8022948,
    zoom: 6,
  };

  const [mapPosition, setMapPosition] = useState<any>(mapLocalStorage);

  let mType = localStorage.getItem(LOCAL_STORAGE.MAP_TYPE);
  const [selectedMapType, setSelectedMapType] = useState<any>(
    mType ? Number(mType) : 0
  );

  useEffect(() => {
    if (shopDetails) {
      mapFitBounds();
    }
  }, [shopDetails]);

  useEffect(() => {
    if (loading) {
      getLeads();
    }
  }, [loading]);

  const getLeads = async () => {
    try {
      const args = {
        minResponse: true,
      };
      const res: any = await CUSTOMER_APIs.getScavengings(args);
      const { status, response } = res;
      if (status === 200) {
        let leadProfile = response.records;
        let leads = leadProfile.filter(
          (lead) =>
            lead.latitude !== 0 &&
            lead.longitude !== 0 &&
            lead.latitude !== null &&
            lead.longitude !== null
        );
        setLeadProfile(leads);
      }
      getCustomers();
    } catch (error) {
      console.error("getLeads:", error);
    }
  };

  const getCustomers = async () => {
    try {
      const args = {
        minResponse: true,
      };
      const res: any = await CUSTOMER_APIs.getCustomerOnMap(args);
      const { status, response } = res;
      if (status === 200) {
        let customerData = response.records;
        let customer = customerData.filter(
          (customer) =>
            customer.lat !== 0 &&
            customer.lng !== 0 &&
            customer.lat !== null &&
            customer.lng !== null
        );
        setCustomers(customer);
      }
      setLoading(false);
    } catch (error) {
      console.error("getCustomers:", error);
    }
  };

  const updateLocation = (pos: any, zoom = DEFAULTS.MAX_ZOOM - 2) => {
    localStorage.setItem(LOCAL_STORAGE.MAP, JSON.stringify({ ...pos, zoom }));
    setMapPosition({ ...pos, zoom });
  };

  setTimeout(() => {
    setLoading(false);
  }, 2000);

  const getTileUrl = (mapType = 0) => {
    localStorage.setItem(LOCAL_STORAGE.MAP_TYPE, mapType.toString());
    let url = CONFIG.OSM_TILE_URL;
    switch (mapType) {
      case 0:
        url = CONFIG.OSM_TILE_URL;
        break;
      case 1:
        url = CONFIG.GOOGLE_STREETS_MAP_URL;
        break;
      case 2:
        url = CONFIG.GOOGLE_SATELLITE_MAP_URL;
        break;
      case 3:
        url = CONFIG.GOOGLE_HYBRID_MAP_URL;
        break;
      default:
        url = CONFIG.OSM_TILE_URL;
        break;
    }
    return url;
  };

  const getMapMarker = (orgId) => {
    let iconUrl = gopalImg;
    if (orgId === "customers") {
      iconUrl = customerMarker;
    } else if (orgId === "leads") {
      iconUrl = leads;
    } else {
      iconUrl = gopalImg;
    }

    let customMarker = null;
    let width = 26;
    let angle = 0;

    const html =
      "<div class='movingMarker' id='movingmarker-" +
      orgId +
      "' style='transform: rotate(" +
      angle.toString() +
      "deg);'><img src='" +
      iconUrl +
      "' alt='' width='" +
      width +
      "px'/></div>";

    customMarker = L.divIcon({
      html: html,
      iconSize: new L.Point(16, 16),
      iconAnchor: null,
      popupAnchor: [0, -3],
      className: "mapMarker",
    });

    return customMarker;
  };

  const mPos = {
    lat: Number(mapPosition.lat),
    lng: Number(mapPosition.lng),
  };
  let zoom = Number(mapPosition.zoom);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setMapTypes(!mapTypes);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMapTypes(false);
  };

  const getScavengingDetails = async () => {
    console.log(fromLatLng.lat, fromLatLng.lng);
    console.log(toLatLng.lat, toLatLng.lng);
    let errors = [];
    if (fromLatLng.lat === 0 && fromLatLng.lng === 0) {
      errors.push({
        msg:
          "<span class='bold'>" +
          LABELS.FROM +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    console.log(errors.length);
    if (toLatLng.lat === 0 && toLatLng.lng === 0) {
      errors.push({
        msg:
          "<span class='bold'>" +
          LABELS.TO +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    console.log(errors.length);
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_REQUIRED_FIELDS
      );
      return;
    }
    if (errors.length === 0) {
      setLoadScavenging(true);
    }
    const args = {
      origin: [fromLatLng.lat, fromLatLng.lng],
      destination: [toLatLng.lat, toLatLng.lng],
      shopTypes,
    };
    const res: any = await AI_APIS.getScavengeRoute(args);
    if (res.status === 200) {
      let shopDetail = res.response.hotels;
      setShopDetails(shopDetail);
      setLoadScavenging(false);
    }
  };

  const polygonFitBounds = (boundData) => {
    let bounds = boundData.map((bound) => ({
      lat: bound[0],
      lng: bound[1],
    }));
    if (!bounds) {
      let layers = shopsRef.current.leafletElement._layers;
      for (let i in layers) {
        bounds = layers[i]._bounds;
      }
    }
    if (bounds) {
      mapRef.current.leafletElement.fitBounds(bounds);
    }
  };

  const mapFitBounds = () => {
    shopsRef.current.leafletElement &&
      mapRef.current.leafletElement.fitBounds(
        shopsRef.current.leafletElement.getBounds()
      );
  };

  //on click shops list
  const getShopLocation = (shop) => {
    const lat = shop.location[0];
    const lng = shop.location[1];
    updateLocation({ lat, lng }, DEFAULTS.MAX_ZOOM);
  };

  const manageSaveShops = () => {
    setSaveLoading(true);
    const args = {
      scavengings: shopDetails.map((shop, i) => {
        return {
          id: -1,
          leadName: shop.name,
          latitude: shop.location[0],
          longitude: shop.location[1],
          // cityId,
          // address,
          // mobileNumber,
          // inchargeId,
          // customerTypeId,
          // photoId,
        };
      }),
    };
    CUSTOMER_APIs.manageScavengings(args).then((res) => {
      if (res.status === 200) {
        setSaveLoading(false);
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
      } else {
        setSaveLoading(false);
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  console.log("leadProfile: ", leadProfile);

  return (
    <>
      <div>
        {/* search bar */}
        <MapSearchFilter
          shopTypes={shopTypes}
          toLatLng={toLatLng}
          fromLatLng={fromLatLng}
          shopDetails={shopDetails}
          showCustomer={showCustomer}
          showLeadProfiles={showLeadProfiles}
          getScavengingDetails={getScavengingDetails}
          setShowLeadProfiles={(val: any) => {
            setShowLeadProfiles(val);
          }}
          setShowCustomer={(val: any) => {
            setShowCustomer(val);
          }}
          setShopTypes={(val: any) => {
            setShopTypes(val);
          }}
          setFromLatLng={(val: any) => {
            setFromLatLng(val);
          }}
          setToLatLng={(val: any) => {
            setToLatLng(val);
          }}
        />
        {loading ? (
          <div>
            <SkeletonBox
              style={{ marginTop: "50px" }}
              height={window.innerHeight * 0.87}
              width={window.innerWidth * 0.92}
            />
          </div>
        ) : (
          <div className="mainDivScavenge">
            <div
              id="mapContainer"
              className={"mapContainer "}
              style={{ overflow: "hidden" }}
            >
              <Map
                center={mPos}
                zoom={zoom}
                maxZoom={DEFAULTS.MAX_ZOOM}
                minZoom={DEFAULTS.MIN_ZOOM}
                viewport={null}
                className="fleetMap"
                zoomControl={true}
                ref={mapRef}
                style={{
                  width: window.innerWidth * 0.92,
                  height: window.innerHeight * 0.87,
                }}
              >
                <TileLayer url={getTileUrl(selectedMapType)} />
                <ZoomControl position="topright" />
                <FeatureGroup ref={shopsRef}>
                  {shopDetails &&
                    shopDetails.map((shop, i) => {
                      return (
                        <Marker
                          position={shop.location}
                          icon={getMapMarker(2)}
                          key={"mapMarker-" + i}
                          className="mapMarker"
                          draggable={false}
                        >
                          <Popup>
                            <div className="popupMainDiv">
                              <div>
                                <h3 className="popupContent">{shop.name}</h3>
                                <p>{shop.location}</p>
                              </div>
                              <div className="popUpImage">
                                <img
                                  src={shop.photo}
                                  alt={shop.name}
                                  className="imgOnMap"
                                ></img>
                              </div>
                            </div>
                          </Popup>
                          <Tooltip
                            direction="right"
                            offset={[10, -2]}
                            className={"makerLabel"}
                            permanent
                          >
                            <span>{shop.name}</span>
                          </Tooltip>
                        </Marker>
                      );
                    })}
                </FeatureGroup>
                {showCustomer &&
                  customers &&
                  customers.map((customer, i) => {
                    return (
                      <Marker
                        position={{
                          lat: Number(customer.latitude),
                          lng: Number(customer.longitude),
                        }}
                        icon={getMapMarker("customers")}
                        key={"mapMarkers-" + i}
                        className="mapMarker"
                        draggable={false}
                      >
                        <Tooltip
                          direction="right"
                          offset={[10, -2]}
                          className={"makerLabel"}
                          permanent
                        >
                          <span>{customer.name}</span>
                        </Tooltip>
                      </Marker>
                    );
                  })}

                {showLeadProfiles &&
                  leadProfile &&
                  leadProfile.map((lead, i) => {
                    return (
                      <Marker
                        position={{
                          lat: lead.latitude,
                          lng: lead.longitude,
                        }}
                        icon={getMapMarker("leads")}
                        key={"mapMarkers-" + i}
                        className="mapMarker"
                        draggable={false}
                      >
                        <Tooltip
                          direction="right"
                          offset={[10, -2]}
                          className={"makerLabel"}
                          permanent
                        >
                          <span>{lead.leadName}</span>
                        </Tooltip>
                      </Marker>
                    );
                  })}
              </Map>
              {/* map types layer
               */}
              <div className="mapTypeFilterScavenging">
                <IconButton
                  aria-label="Map Types"
                  size="large"
                  className="scavengeMapFilter"
                  style={
                    shopDetails
                      ? {
                          right: "575px",
                        }
                      : {
                          right: "0px",
                        }
                  }
                  onClick={handleClick}
                >
                  <LayersIcon />
                </IconButton>
              </div>
              <Popover
                style={{ margin: "-12px" }}
                open={mapTypes}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
              >
                <List dense className="mapTypes uiPopOver">
                  {DEFAULTS.MAP_TYPES.map((m, i) => {
                    return (
                      <ListItem
                        key={"mtype-" + i}
                        disablePadding
                        onClick={() => {
                          setSelectedMapType(i);
                          setMapTypes(false);
                        }}
                        className={i === selectedMapType ? "active" : ""}
                      >
                        <ListItemButton>
                          <ListItemText primary={m} className="listText" />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
              </Popover>
            </div>
            {/* shopDetails SideBar */}
            {shopDetails && (
              <>
                <div
                  className="mainShopDiv"
                  style={{
                    height: window.innerHeight * 0.87,
                  }}
                >
                  <div
                    className="mainShopDetailDiv"
                    style={{
                      height: "93%",
                      right: 10,
                    }}
                  >
                    {shopDetails.map((shop, index) => {
                      return (
                        <div
                          className="SubShopDetailsDiv"
                          onClick={() => getShopLocation(shop)}
                        >
                          <div className="shopsIconDiv">
                            <IconButton
                              style={{ width: "70px", height: "70px" }}
                            >
                              <StoreIcon fontSize="large" />
                            </IconButton>
                          </div>
                          <div>
                            <h4
                              id={"shop" + index}
                              className="shopNameHead"
                              style={{}}
                            >
                              {index + 1 + ". " + shop.name}
                            </h4>
                            <p className="shopAddress" style={{}}>
                              {shop.location[0] + ", " + shop.location[1]}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="saveBtn">
                    <Btn
                      text={LABELS.SAVE}
                      bgColor={COLORS.GRID_ADD_NEW}
                      onClick={manageSaveShops}
                    />
                  </div>
                </div>
                {saveLoading && (
                  <>
                    <div className="progressBar">
                      <LinearProgress />
                    </div>
                    <div className="radarOverLay">
                      <Loader size="40px"></Loader>
                      <p className="bold">Please wait</p>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        )}
      </div>
      {loadScavenging && (
        <>
          <div className="progressBar">
            <LinearProgress />
          </div>
          <div className="radarOverLay">
            <Loader size="40px"></Loader>
            <p className="bold">Please wait</p>
          </div>
        </>
      )}
    </>
  );
};

export default withSnackbar(Scavenging);
